import { useEffect, useState } from 'react';
import { getAnchor } from './anchor';

const useActiveHeaders = (headers) => {
  const [activeHeaders, setActiveHeaders] = useState([]);

  useEffect(() => {
    const headersElements = headers.map((h) => {
      const anchor = getAnchor(h);
      return {
        anchor,
        el: document.getElementById(anchor)
      };
    });

    const onScroll = () => {
      const pastHeaders = getPastHeaders(headersElements);
      const currentHeader = getCurrentHeader(headersElements);

      setActiveHeaders([...pastHeaders, currentHeader]);
    };

    document.body.addEventListener('scroll', onScroll);
    onScroll();

    return () => {
      document.body.removeEventListener('scroll', onScroll);
    };
  }, [headers.join(',')]);

  return { activeHeaders };
};

function getPastHeaders(headers) {
  return headers
    .filter((h) => document.body.scrollTop > getAbsoluteOffsetTop(h.el, true))
    .map((h) => h.anchor);
}

function getCurrentHeader(headers) {
  const currentHeader = headers
    .find((h) => {
      const absoluteOffsetTop = getAbsoluteOffsetTop(h.el, true);
      return document.body.scrollTop < absoluteOffsetTop && (document.body.scrollTop + window.innerHeight) > absoluteOffsetTop;
    });

  return currentHeader ? currentHeader.anchor : null;
}

function getAbsoluteOffsetTop(el, includeHeight) {
  let offset = 0;
  if (el.offsetParent) {
    offset = el.offsetTop + getAbsoluteOffsetTop(el.offsetParent);
  } else {
    offset = el.offsetTop || 0;
  }

  if (includeHeight) {
    offset += (el.clientHeight || 0);
  }

  return offset;
}

export default useActiveHeaders;
